import Vue from 'vue';
import VueRouter from 'vue-router';

import OnboardingView from '@/views/OnboardingView.vue';
import BalanceView from '@/views/BalanceView.vue';

import authGuard from '@/plugins/auth0/auth-guard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/onboarding',
    name: 'onboarding',
    component: OnboardingView,
    meta: {
      redirectIfAuthenticated: { name: 'balance' },
    },
  },
  // {
  //   path: '/signup',
  //   name: 'signup',
  //   component: () => import(/* webpackChunkName: "signup-view" */ '../views/SignupView.vue'),
  //   meta: {
  //     layout: 'authentication',
  //     loginRequired: true,
  //   },
  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import(/* webpackChunkName: "login-view" */ '../views/LoginView.vue'),
  //   meta: {
  //     layout: 'authentication',
  //     loginRequired: true,
  //   },
  // },
  {
    path: '/balance',
    name: 'balance',
    component: BalanceView,
    meta: {
      layout: 'tab-bar',
      requiresAuthentication: true,
    },
  },
  {
    path: '/stations',
    name: 'stations',
    component: () => import(/* webpackChunkName: "stations-view" */ '../views/StationsView.vue'),
    meta: {
      layout: 'tab-bar',
      requiresAuthentication: true,
    },
  },
  {
    path: '/earn',
    name: 'earn',
    component: () => import(/* webpackChunkName: "earn-view" */ '../views/EarnView.vue'),
    meta: {
      layout: 'tab-bar',
      requiresAuthentication: true,
    },
  },
  {
    path: '/offers',
    name: 'offers',
    component: () => import(/* webpackChunkName: "offers-view" */ '../views/OffersView.vue'),
    meta: {
      layout: 'tab-bar',
      requiresAuthentication: true,
    },
  },
  {
    path: '/operator',
    name: 'operator',
    component: () => import(/* webpackChunkName: "operator-view" */ '../views/OperatorView.vue'),
    meta: {
      layout: 'tab-bar',
      requiresAuthentication: true,
      requiresRoles: ['operator'],
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "about-view" */ '../views/SettingsView.vue'),
    meta: {
      layout: 'tab-bar',
      requiresAuthentication: true,
    },
  },
  {
    path: '/',
    redirect: { name: 'onboarding' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.redirectIfAuthenticated) {
    // console.log('REDIRECTS IF AUTHENTICATED');
    return authGuard((authService, t, f, n) => {
      // console.log(`IS AUTHENTICATED: ${authService.isAuthenticated}`);
      n(authService.isAuthenticated ? to.meta.redirectIfAuthenticated : undefined);
    })(to, from, next);
  }
  if (to.meta.requiresAuthentication) {
    // console.log('REQUIRES AUTHENTICATION');
    return authGuard(async (authService, t, f, n) => {
      // If the user is authenticated, continue with the route
      // console.log(`IS AUTHENTICATED: ${authService.isAuthenticated}`);
      if (authService.isAuthenticated) {
        if (t.meta.requiresRoles) {
          // Perform role checking
          const { flattenedOrganizationRoles } = await authService.getUserRoles();
          return n(t.meta.requiresRoles.every((r) => flattenedOrganizationRoles[r]) ? undefined : (from.path || { name: 'balance' }));
        }
        return n();
      }
      // Otherwise, log in
      return authService.loginWithRedirect({ appState: { targetUrl: t.fullPath } });
    })(to, from, next);
  }
  return next();
});

export default router;
